import { render, staticRenderFns } from "./ConstructDocumentationPopup.vue?vue&type=template&id=6c52b9d6"
import script from "./ConstructDocumentationPopup.vue?vue&type=script&lang=ts"
export * from "./ConstructDocumentationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports